/* eslint-disable */
import React, { forwardRef, useEffect, useImperativeHandle, useState, useContext } from 'react';
import { IonCard, IonCardContent, IonItem, IonButton, IonIcon } from '@ionic/react';
import { addOutline, removeOutline, trashOutline } from 'ionicons/icons';

import '../../../styles/fight/items/ItemCard.scss';

/**
 * Ideally, we could abstract this and ItemCard.js, but I just copied
 * it for the sake of time
 */
function TakerItemCard({ item, onAmountChange, isNotEditable }) {
  const [itemAmount, setItemAmount] = useState(item.amount ?? item.quantity ?? 0);

  useEffect(() => {
    if (typeof onAmountChange === 'function') {
      onAmountChange(itemAmount);
    }
  }, [itemAmount]);

  return (
    <IonCard className='item-card'>
      <IonCardContent>
        <div className='item-card-wrapper'>
          <div className='item-card-info'>
            <p>{item.name}</p>
          </div>
          <div className='price'>
            <p>${item.formattedPrice || (item.price / 100).toFixed(2)}</p>
          </div>
        </div>
        <IonItem>
          <div className='quantity-control-container'>
            <IonButton
              fill='clear'
              size='small'
              className={`quantity-button ${isNotEditable || itemAmount <= 0 ? 'hidden' : ''}`}
              onClick={() => setItemAmount(old => Math.max(old - 1, 0))}>
              <IonIcon icon={itemAmount === 1 ? trashOutline : removeOutline} slot='icon-only' />
            </IonButton>
            <p className='quantity-value'>{itemAmount}</p>
            <IonButton
              fill='clear'
              size='small'
              className={`quantity-button ${isNotEditable ? 'hidden' : ''}`}
              onClick={() => setItemAmount(old => Math.max(old + 1, 0))}>
              <IonIcon icon={addOutline} slot='icon-only' />
            </IonButton>
          </div>
        </IonItem>
      </IonCardContent>
    </IonCard>
  );
}

export default TakerItemCard;
